import type { MailboxInfo } from 'owa-client-types';
import { action } from 'satcheljs';
import type { ActionType } from '../types/ActionType';
import type { LightningId } from '../types/LightningId';

export interface LightedActionMessage {
    id: string;
    actionType: ActionType | undefined;
    mailboxInfo: MailboxInfo | undefined;
}
const defaultExport: (
    id: LightningId,
    actionType?: ActionType,
    mailboxInfo?: MailboxInfo
) => LightedActionMessage = action(
    'lighted',
    (
        id: LightningId,
        actionType?: ActionType,
        mailboxInfo?: MailboxInfo
    ): LightedActionMessage => ({
        id,
        actionType,
        mailboxInfo,
    })
);
export default defaultExport;
